// extracted by mini-css-extract-plugin
module.exports = {"baldeTreaserA":"A_baldeTreaserA__HSs_5"};